fragment CompareTableFragment on compareTable_Entry {
  typeHandle
  heading
  showFilters
  collectionHandle: compareCollection
}
